<template>
  <div class="container-main-div">
    <!-- ++++++++++++ Radio Buttons ++++++++++++++++++++++++++++ -->

    <div class="fieldset">
      <form>
        <fieldset class="customLegend row">
          <legend style="margin-left: 30px">Choose Control Setup</legend>
          <div class="float-container">
            <!-- ----------- pretty ------------- -->
            <div class="float-child" style="width: 100px">
              <input
                type="checkbox"
                @change="handlePrettyCheckbox($event)"
                id="checkboxPrettyID"
                name="checkboxPretty"
              />
              <label class="lableMargin" for="checkboxPretty">Pretty</label>
            </div>
            <!-- ----------- sorting ------------- -->
            <div class="float-child"  style="width: 100px">
              <input
                type="checkbox"
                @change="handleSortCheckbox($event)"
                id="checkboxSortID"
                name="checkboxSort"
              />
              <label class="lableMargin" for="checkboxSort">Sorting</label>
            </div>
            <!-- ----------- rows per page ------------- -->
            <div class="float-child"  style="width: 150px">
              <input
                type="checkbox"
                @change="handleRppCheckbox($event)"
                id="checkboxRppID"
                name="checkboxRpp"
              />
              <label class="lableMargin" for="checkboxSort"
                >Rows per Page</label
              >
            </div>

            <!-- ----------- max pages per control ------------- -->
            <div class="float-child" style="width: 230px">
              <select id="selPagesPerControl" v-model="maxPPC" style="margin: 0px">
                <option v-for="item in ppcArray" :value="item" :key="item">
                  {{ item }}
                </option>
              </select>
              <label class="lableMargin" for="selPagesPerControl">max Pages per Control</label>
            </div>
            
          </div>
        </fieldset>
      </form>
    </div>

    <!-- ++++++++++++ GRID ++++++++++++++++++++++++++++ -->

    <div class="gridWidth">
      <CmpGrid
        :GridData="gridTime"
        :EnablePaging="true"
        :EnableSearching="true"
        :EnableSorting="sortingIsChecked"
        :HeaderArrays="headerArrays"
        :RowsPerPageArray="rowsPerPage"
        :MaximumPagesInControl="maxPPC"
      ></CmpGrid>
    </div>
  </div>
</template>

<script>
import CmpGrid from "../../../components/dataSupport/CmpGrid.vue";
import axios from "axios";

export default {
  name: "HomeView",
  data() {
    return {
      gridTime: { grid: null, time: null },
      prettyIsChecked: false,
      sortingIsChecked: false,
      rowsPerPage: new Array(),
      headerArrays: null,
      ppcArray: [1,2,3,4,5,6,7,8,9],
      maxPPC: null,
    };
  },
  created() {
    // console.log("----> HostCmpGrid.vue:created()");
    this.getAllUsers();
    this.$data.maxPPC = this.$data.ppcArray[2];
  },

  methods: {
    getAllUsers() {
      // console.log("HostCmpGrid.vue:getAllUsers()");
      axios
        .get("https://localhost:7100/api/User/SelAllUsers")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          // console.log("---->> last then: HostCmpGrid getAllUsers()");
          // console.log("data = ", data);
          // console.log("data.length = ", data.length);
        });
    },

    handlePrettyCheckbox() {
      let prettyCheckbox = document.querySelector("#checkboxPrettyID");
      this.$data.prettyIsChecked = prettyCheckbox.checked;

      //The names orderRawNames and orderedCustomNames must be used
      //in the headers array json object below.
      if (this.$data.prettyIsChecked == true) {
        this.headerArrays = {
          orderRawNames: ["role", "lastName", "firstName"],
          orderedCustomNames: ["Role", "Last Name", "First Name"],
        };
      } else {
        this.headerArrays = null;
      }
    },

    handleSortCheckbox() {
      let sortCheckbox = document.querySelector("#checkboxSortID");
      this.$data.sortingIsChecked = sortCheckbox.checked;
      // console.log("sortCheckbox = ", sortCheckbox.checked);
    },

    handleRppCheckbox() {
      let rppCheckbox = document.querySelector("#checkboxRppID");

      if (rppCheckbox.checked) {
        this.$data.rowsPerPage = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      } else {
        this.$data.rowsPerPage = new Array();
      }
    },
  },
  components: { CmpGrid },
};
</script>

<style scoped>
.container-main-div {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 0px;
  margin-top: 20px;
  /* background-color: rgb(193, 236, 190); */
}

.gridWidth {
  width: 80%;
  margin-bottom: 50px;
}

/* ****************** radio buttons ********************* */

.fieldset {
  width: 600px;
  margin-left: 0%;
  margin-top: 0px;
  margin-bottom: 15px;
}
.float-container {
  border: 1px solid darkblue;
  padding: 5px;
}
.float-child {
  width: 20%;
  float: left;
  padding: 5px;
  margin-top: 5px;
}

.lableMargin {
  margin-left: 10px;
}
.customLegend {
  border: 1px solid #e5e5e5;
  padding: 0px;
  margin-top: 5px;
  position: relative;
}
.customLegend legend {
  border: 0;
  background: #fff;
  width: auto;
  font-size: 12px;
  transform: translateY(-50%);
  position: absolute;
  top: 0;
  left: 0;
  padding: 5px;
}
</style>
